module.exports = __webpack_public_path__ + "img/picture_kcmn.1d2918c4.png";